// extracted by mini-css-extract-plugin
module.exports = {"root":"NotFound_root__2THBY","errorCode":"NotFound_errorCode__xpklr"};